import React from "react";
import { Badge, Flex, MantineSize } from "@mantine/core";
import { VideoEvent } from "../../client";
import { getDisplayTags, sortDisplayTags, getBadgeStyles } from "../../utils/tagUtils";

interface EventTagBadgesProps {
  video: VideoEvent;
  targetPlayerId?: string | null;
  targetPlayerName?: string | null;
  size?: MantineSize;
  maxTags?: number;
  className?: string;
}

/**
 * Renders a row of sorted, colour-coded Mantine Badge elements
 * derived from a VideoEvent's tags.
 *
 */
const EventTagBadges: React.FC<EventTagBadgesProps> = ({
  video,
  targetPlayerId,
  targetPlayerName,
  size = "xs",
  maxTags,
  className,
}) => {
  const allTags = sortDisplayTags(getDisplayTags(video, targetPlayerId, targetPlayerName));
  const tags = maxTags && maxTags > 0 ? allTags.slice(0, maxTags) : allTags;

  if (tags.length === 0) return null;

  return (
    <Flex wrap="wrap" gap={4} className={className}>
      {tags.map((tag, idx) => {
        const styles = getBadgeStyles(tag);
        return (
          <Badge
            key={idx}
            size={size}
            variant={styles.variant}
            color={styles.color}
            radius="sm"
          >
            {tag}
          </Badge>
        );
      })}
    </Flex>
  );
};

export default EventTagBadges;
